
import {take} from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase';


import { BehaviorSubject } from 'rxjs';
import { NotificationService } from '../../modules/api';

@Injectable()
export class MessagingService {
  messaging;
  currentMessage = new BehaviorSubject(null);
  totalNoti = new BehaviorSubject(null);
  constructor(
    private db: AngularFireDatabase,
    private afAuth: AngularFireAuth,
    private noti: NotificationService
  ) {
    try {
      this.messaging = firebase.messaging();
    } catch (e) {
      console.log('Unable to Listen PUSH Messages', e);
    }
  }

  updateToken(token) {
    this.afAuth.authState.pipe(take(1)).subscribe(user => {
      if (!user) { return; }

      const data = { [user.uid]: token };
      this.db.object('fcmTokens/').update(data);
    });
  }

  getPermission() {
    this.messaging.requestPermission()
      .then(() => {
        console.log('Notification permission granted.');
        return this.messaging.getToken();
      })
      .then(token => {
        console.log(token);
        localStorage.setItem('token', token);
        this.updateToken(token);
      })
      .catch((err) => {
        // localStorage.removeItem('token');
        console.log('Unable to get permission to notify.', err);
      });
  }

  receiveMessage() {
    try {
      this.messaging.onMessage((payload) => {
        console.log('Message received. ', payload);
        this.noti.apiNotificationsMyNotificationsByPageByLimitGet(1, 10)
          .subscribe(data => {
            this.totalNoti.next(data.totalUnread);
          });
        this.currentMessage.next(payload);
      });
    } catch (e) {
      console.log('Unable to Listen PUSH Messages', e);
    }
  }
}
